import { fromJS } from 'immutable';

export function request(state, { chatId }) {
    return state
        .setIn([ 'items', chatId, 'state' ], 'IN_PROGRESS');
}

export function error(state, { chatId, errors }) {
    errors = fromJS(errors);

    return state
        .setIn([ 'items', chatId, 'state' ], 'ERROR')
        .setIn([ 'items', chatId, 'errors' ], errors);
}

export function finish(state, { chatId, messageId }) {
    const messages = state.getIn([ 'items', chatId, 'messages' ]);
    const filtered = messages.filter(msg => msg.get('id') !== messageId);

    return state
        .setIn([ 'items', chatId, 'messages' ], filtered)
        .setIn([ 'items', chatId, 'state' ], 'FINISHED');
}
